import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout/Layout';
import { MasterDataPage } from './components/MasterData/MasterDataPage';
import { WeighingPage } from './components/Weighing/WeighingPage';
import { StatisticsPage } from './components/Statistics/StatisticsPage';
import { HorseProvider } from './contexts/HorseContext';
import { HorseSelectionPage } from './components/Weighing/HorseSelectionPage';
export function App() {
  return <HorseProvider data-id="element-0">
      <Router data-id="element-1">
        <Layout data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/master-data" element={<MasterDataPage data-id="element-5" />} data-id="element-4" />
            <Route path="/select-horse" element={<HorseSelectionPage data-id="element-7" />} data-id="element-6" />
            <Route path="/weighing" element={<WeighingPage data-id="element-9" />} data-id="element-8" />
            <Route path="/statistics" element={<StatisticsPage data-id="element-11" />} data-id="element-10" />
            <Route path="/" element={<Navigate to="/master-data" replace data-id="element-13" />} data-id="element-12" />
          </Routes>
        </Layout>
      </Router>
    </HorseProvider>;
}